import banner from "../assets/images/banner.png";
import laptop from "../assets/images/laptop.png";
import phone from "../assets/images/phone.png";

function Banner() {
  return (
    <div className="main-banner">
      <picture>
        <source media="(max-width: 767px)" srcSet={phone} />
        <source media="(max-width: 1023px)" srcSet={laptop} />
        <img src={banner} alt="banner" />
      </picture>
    </div>
  );
}

export default Banner;